<div
  *ngIf="currentBanner() as b"
  class="sticky-banner d-flex align-items-center px-3"
  [style.background-color]="bannerBgColor(b.color)"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  [class.sticky-banner--expanded]="expanded()"
>
  <!-- Collapsed: solo texto -->
  <div class="flex-fill d-flex align-items-center gap-2 min-width-0" *ngIf="!expanded()">
    <svg cIcon name="cilBullhorn" size="sm" class="text-white flex-shrink-0"></svg>
    <span class="text-white small fw-semibold text-truncate">{{ b.title }}</span>
    <span class="text-white-50 small text-truncate d-none d-md-inline">{{ b.description }}</span>
  </div>

  <!-- Expanded: con imagen -->
  <div class="flex-fill d-flex align-items-center gap-3 min-width-0" *ngIf="expanded()">
    <div
      *ngIf="b.imageSignedUrl"
      class="flex-shrink-0 rounded overflow-hidden"
      style="width: 80px; height: 52px;"
    >
      <img
        [src]="b.imageSignedUrl"
        alt=""
        style="width: 100%; height: 100%; object-fit: cover;"
      />
    </div>
    <div class="min-width-0 flex-fill">
      <div class="text-white fw-semibold small">{{ b.title }}</div>
      <div class="text-white-50 small text-truncate">{{ b.description }}</div>
    </div>
    <button
      *ngIf="b.linkUrl"
      class="btn btn-sm btn-outline-light flex-shrink-0"
      (click)="openLink(b.linkUrl); $event.stopPropagation()"
    >
      Ir al enlace
    </button>
  </div>

  <!-- Indicadores + cerrar -->
  <div class="d-flex align-items-center gap-2 flex-shrink-0 ms-2">
    <span *ngIf="banners().length > 1" class="text-white-50 small">
      {{ (activeIndex() % banners().length) + 1 }}/{{ banners().length }}
    </span>
    <button
      class="btn btn-sm p-0 text-white-50 border-0"
      style="font-size: 18px; line-height: 1;"
      title="Cerrar este banner"
      (click)="dismiss(); $event.stopPropagation()"
    >&times;</button>
  </div>
</div>
